<ul class="grid row">
    <li *ngFor="let layout of layouts" [class.active]="current.layoutRef === layout.id" class="col-3 mb-2">
        <figure (click)="selectLayout(layout.id)">
            <span class="media">
                <img class="vertical" [src]="'assets/img/'+layout.img" [alt]="layout.titleRef | translate">
                <span class="state">
                    <svg class="icon-action-select-thumb" aria-hidden="true">
                        <use xmlns:xlink="http://www.w3.org/1999/xlink" xlink:href="assets/img/icons.svg#icon-action-select-thumb"></use>
                    </svg>
                </span>
            </span>
            <figcaption>
                <p>{{ layout.titleRef | translate }}</p>
                <p *ngIf="layout.subTitleRef"><small>{{ layout.subTitleRef | translate }}</small></p>
            </figcaption>
        </figure>
    </li>
</ul>
<p class="disclaimer mb-5">{{ "need_mapping.layout.disclaimer" | translate}}</p>
<div class="text-center">
    <label class="bt-text" (click)="selectLayout('')">{{ "need_mapping.no_choice.info" | translate }}</label>
</div>